/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import ContentHeader from '../ContentHeader';
import ContentBody from '../ContentBody';

class ContentWrapper extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
        <ContentHeader />
        <ContentBody {...this.props}>
          {children}
        </ContentBody>
      </div>
    );
  }
}

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/js/common/components/Theme/Content/ContentWrapper/index.jsx